<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <defs>
      <path id="a" d="M.25.125h.125V.25H.25z" />
      <path id="c" d="M0 0h81.746v99.834H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(0 99.667)">
        <mask id="b" fill="#fff">
          <use xlink:href="#a" />
        </mask>
      </g>
      <path :fill="iconColor" d="M33.799 64.229l-1.683 4.284h3.365z" />
      <g transform="translate(.167)">
        <path
          :fill="iconColor"
          d="M59.35 75.204h-4.771l-4.563-6.118h-1.66v6.118H44.21v-16.04h7.582c1.781 0 3.187.467 4.217 1.398 1.06.917 1.59 2.101 1.59 3.552 0 1.039-.277 1.956-.83 2.75-.553.794-1.321 1.382-2.304 1.764l4.885 6.576zm-34.453 0l6.776-16.13h3.986l6.775 16.13h-4.447l-1.36-3.391h-5.991l-1.36 3.39h-4.379zm46.165 18.122H16.037c-2.282 0-4.14-1.847-4.14-4.118v-4.762h51.297c2.378 0 4.306-1.915 4.306-4.28V54.198c0-2.366-1.928-4.282-4.306-4.282H11.897V10.625c0-2.265 1.858-4.112 4.14-4.112l16.664-.017V8.71h-5.26v3.486h5.26v3.486h-5.26v3.486h5.26v1.743h-1.753c-.805 0-1.506.544-1.701 1.32l-3.625 14.419a6.942 6.942 0 0 0 1.275 5.981 7.028 7.028 0 0 0 5.527 2.681h4.06c2.159 0 4.197-.989 5.526-2.68a6.942 6.942 0 0 0 1.276-5.982l-3.625-14.419a1.751 1.751 0 0 0-1.701-1.32h-1.753v-5.23h5.259v-3.485h-5.26V8.71h5.26V6.487l12.45-.013v13.922c0 4.067 3.319 7.368 7.412 7.368l13.715-.039.155 61.483c0 2.271-1.854 4.118-4.136 4.118zM9.412 59.165h7.581c1.782 0 3.188.466 4.218 1.397 1.06.917 1.59 2.101 1.59 3.552 0 1.039-.277 1.956-.83 2.75-.553.794-1.322 1.382-2.305 1.764l4.886 6.576h-4.77l-4.563-6.118h-1.66v6.118H9.413v-16.04zm26.384-25.787a3.486 3.486 0 0 1 2.164 3.22c0 1.926-1.57 3.487-3.506 3.487a3.506 3.506 0 0 1-3.24-2.152 3.472 3.472 0 0 1 .76-3.8 3.521 3.521 0 0 1 3.822-.755zM56.366 0H16.036C10.146 0 5.35 4.77 5.35 10.625v39.292H4.306C1.928 49.917 0 51.833 0 54.199v25.966c0 2.366 1.928 4.281 4.306 4.281H5.35v4.762c0 5.861 4.796 10.626 10.687 10.626h55.025c5.889 0 10.684-4.765 10.684-10.626v-64.06L56.366 0z"
        />
      </g>
      <path
        :fill="iconColor"
        d="M53.076 63.071c-.331-.282-.78-.423-1.349-.423h-3.203v3.07h3.203c.569 0 1.018-.134 1.349-.401.33-.267.495-.638.495-1.111 0-.474-.165-.852-.495-1.135M18.278 65.317c.33-.267.496-.638.496-1.111 0-.474-.166-.852-.496-1.135-.33-.282-.78-.423-1.348-.423h-3.203v3.07h3.203c.568 0 1.018-.134 1.348-.401"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-rar',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
